import styled, { css } from 'styled-components'
import {
  HEADER_HEIGHT_DESKTOP,
  HEADER_HEIGHT_MOBILE_PARTIAL,
} from 'constants/common'
import { mq } from 'Theme'

const scrollMarginTop = css`
  scroll-margin-top: ${HEADER_HEIGHT_MOBILE_PARTIAL};
  ${mq.from.TABLET`
      scroll-margin-top: ${HEADER_HEIGHT_DESKTOP}; 
   `}
`

export const H2 = styled('h2')`
  ${scrollMarginTop}
`

export const H3 = styled('h3')`
  ${scrollMarginTop}
`
